import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorModalComponent } from './error-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ErrorModalComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  exports: [ErrorModalComponent],
})
export class ErrorModalModule {}
